import { Pipe, PipeTransform } from '@angular/core';

import { isNullOrUndefined } from '@lib/utils';

@Pipe({ name: 'metricUnits' })
export class MetricUnitsPipe implements PipeTransform {
  /**
   * This function returns metric or imperial units
   * based upon the type of quantity.
   *
   * @param {boolean} isMetricUnits Flag to decide between metric or imperial units
   * @param {any} quantity If the quantity is null or undefined, return undefined; to prevent displaying units alone
   * @param {string} type The type of quantity for which the units exist; e.g. length, speed, or weight
   * @param {boolean} showQuantity shows the original quantity along with the unit
   * @returns {string} Metric or imperial units
   */
  public transform(isMetricUnits: boolean, quantity?: any, type: string = 'distance', showQuantity: boolean = false): string {
    if (arguments.length > 1 && isNullOrUndefined(quantity)) return undefined;
    let unit: string;

    switch (type) {
    case 'fuel':
      unit = isMetricUnits ? $localize`l` : $localize`gal`;
      break;
    case 'fuelEfficiency':
      unit = isMetricUnits ? $localize`L/100KM` : $localize`MPG`;
      break;
    case 'fuelEfficiency-km/l':
      unit = isMetricUnits ? $localize`KM/L` : $localize`MPG`;
      break;
    case 'speed':
      unit = isMetricUnits ? $localize`kph` : $localize`mph`;
      break;
    case 'acceleration':
      unit = isMetricUnits ? $localize`kph/s` : $localize`mph/s`;
      break;
    case 'length':
      unit = isMetricUnits ? $localize`m` : $localize`ft`;
      break;
    case 'weight':
      unit = isMetricUnits ? $localize`kg` : $localize`lbs`;
      break;
    case 'temperature':
      unit = isMetricUnits ? $localize`°C` : $localize`°F`;
      break;
    case 'distanceSqM':
      unit = isMetricUnits ? $localize`square meters` : $localize`square feet`;
      break;
    case 'distanceSqKm':
      unit = isMetricUnits ? $localize`square kilometers` : $localize`square miles`;
      break;
    case 'pressure':
      unit = isMetricUnits ? $localize`kPa` : $localize`psi`;
      break;
    case 'weightTonne':
      unit = isMetricUnits ? $localize`tonne` : $localize`ton`;
      break;
    case 'distance':
    default:
      unit = isMetricUnits ? $localize`km` : $localize`mi`;
      break;
    }

    return showQuantity ? `${quantity} ${unit}` : unit;
  }
}
